import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Input } from 'semantic-ui-react';
import { COMPARISON_OPTIONS } from '../../fieldsConfig';

const ComparisonValue = ({ rule, onValueChange, disabled }) => (
  <div className='comparison-value'>
    <Dropdown
      selection
      options={COMPARISON_OPTIONS}
      value={rule.comparison}
      onChange={(e, data) => onValueChange(rule.instanceId, 'comparison', data.value)}
      disabled={disabled}
    />
    <Input
      type='number'
      value={rule.comparisonValue}
      onChange={(e, data) => onValueChange(rule.instanceId, 'comparisonValue', data.value)}
      disabled={disabled}
    />
  </div>
);

ComparisonValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ComparisonValue;
